import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ValidatorsService } from 'src/app/services/validators/validators.service';

@Component({
  selector: 'app-client-password',
  templateUrl: './client-password.component.html',
  styleUrls: ['./client-password.component.css']
})
export class ClientPasswordComponent implements OnInit {


  innerHeight: number = window.innerHeight;


  // Loaders
  loaders: any = {
    page: true,
    forms: false,
    countries: false
  };
  statusMessage: string|any;

  // Forms
  passwordForm: FormGroup|any;

  clientAccount$: any;
  error$: string|any;


  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<ClientPasswordComponent>,
    private clientApi: ClientaccountService,
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private vs: ValidatorsService
  ) {


    this.clientAccount$ = data.clientAccount;


    this.auth.getError.subscribe((data) => {
      this.error$ = data;
    });

  }

  ngOnInit() {
    this.creatPasswordForm();
  }




  creatPasswordForm(): void {
 
    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confPassword: ['', [Validators.required]]
    }, {
      validator: this.vs.MatchPassword
    });

  }


  submitNewPassword(formDirective: FormGroupDirective, panel: any): void {
    const that = this;
    const formVal = that.passwordForm.value;

    if (that.passwordForm.valid) {

      that.beforeCallApi("Modification de votre mot de passe");
      that.auth.updatePassword(formVal.password).then(data => {
        that.afterCallApi(panel, formDirective, data);

      })
    }
  }


  reLog() {
    this.auth.logOut("/auth/home%22account");
  }

  
  // Automate stains

  beforeCallApi(message: string) {
    this.statusMessage = message;
    this.error$ = "";
    this.loaders.forms = true;
  }


  afterCallApi(panel: any, formDirective: FormGroupDirective, data: any) {

    if (data) {
      this.clientApi.setCurrClientAccount(data);
    }

    this.closeDial(data);

    this.loaders.forms = false;
  }




  closeDial(data?: any) {

    if (data && !this.passwordForm.valid) {
      return;
    }

    this.dialogRef.close(data);
  }

}
